module.exports = __webpack_public_path__ + "img/japanese_2.77472af8.png";